import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Axios from "../axiosInstance";
import { apiEndPoints } from "../../api/apiEndpoints";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

export const fetchTermsData = createAsyncThunk(
  "fetchTermsData",
  (_, { rejectWithValue }) => {
    return Axios.get(
      `${apiEndPoints.tc}`
    ).then((res) => res.data);
  }
);

export const termsSlice = createSlice({
  name: "terms slice",
  initialState,
  reducers: {
    clearUtilsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // FETCH  UTILS API
    builder.addCase(fetchTermsData.pending, (state, action) => {
      if (!state.data) {
        state.isLoading = true;
      }
    });
    builder.addCase(fetchTermsData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchTermsData.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error?.message;
    });
  },
});

// SELECTORS
export const selectTermsWhole = (store) => store?.terms;
export const selectTermsLoader = (store) => store?.terms?.isLoading;

// ACTIONS TO DISPATCH
export const { clearUtilsError } = termsSlice.actions;

export default termsSlice.reducer;
